import React from "react";
import { IconT } from "types/utils";

const SendPlaneIcon = ({ height = "17", width = "17", fill = "currentColor" }: IconT) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 20" fill="none" aria-hidden>
      <path d="M3 10l14-6-6 14-2-6z" stroke={fill} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
export default SendPlaneIcon;
